import axios from 'axios'
import config from '../config'

class AddressInputService {
    async getAddress(cords) {
        return await axios
            .get(`${config.api.kladr}/get_address?lon=${cords.lng}&lat=${cords.lat}`)
            .then(res => {
                if (!res.data.success) {
                    return { success: false }
                }
                return res.data
            })
            .catch(err => console.log(err))
    }

    async getCoordinates(address, region) {
        return await axios
            .get(`${config.api.kladr}/v3/get_coords?${region ? 'region=' + region : ''}&address=${address}`)
            .then(res => {
                if (!res.data.success) {
                    return { success: false }
                }
                return res.data
            })
            .catch(err => console.log(err))
    }

    async getAddressHints(address, region) {
        return await axios
            .get(`${config.api.kladr}/v3/get_hints?${region ? 'region=' + region : ''}&address=${address}`)
            .then(res => {
                if (!res.data.success) {
                    return { success: false }
                }
                return res.data
            })
            .catch(err => {
                console.log(err)
                return { success: false }
            })
    }
}

export default new AddressInputService()
